module.exports = fox._r("images/chat-gifts/gift-22.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/chat-gifts/gift-22.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/chat-gifts/gift-22.png
// module id = 246
// module chunks = 4